import { Link, Typography } from '@forgeglobal/design-framework';
import { FORGETRUST } from '@tcs/common/assets/constants';

const NeedHelp = () => {
  const { PHONE, EMAIL } = FORGETRUST;
  return (
    <Typography variant="body1" data-test-id="contact-text">
      Need help? Contact us at <Link href={`mailto:${EMAIL}`}>{EMAIL}</Link> or{' '}
      <Link href={`tel:+${PHONE}`}>{PHONE}</Link>
    </Typography>
  );
};

export default NeedHelp;
